var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_350_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.34033 15.5563C4.96221 16.3303 5.52825 17.1456 6.03434 17.9963C6.46641 18.7964 6.64652 19.3389 6.96229 20.3029C7.15594 20.8355 7.33096 20.9944 7.70725 20.9944C8.11729 20.9944 8.30332 20.724 8.44705 20.3058C8.74553 19.3954 8.97973 18.7006 9.34922 18.0441C10.0743 16.7767 10.9752 15.6504 11.8604 14.568C12.1001 14.2616 13.6495 12.4768 14.3471 11.0686C14.3471 11.0686 15.2044 9.52162 15.2044 7.36114C15.2044 5.34022 14.3589 3.9386 14.3589 3.9386L11.9246 4.57524L10.4463 8.37761L10.0806 8.90192L10.0075 8.99691L9.9102 9.11581L9.73945 9.30573L9.49547 9.54394L8.17904 10.5913L4.88783 12.4471L4.34033 15.5563Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.943359 10.8085C1.74662 12.6003 3.29561 14.1753 4.34361 15.5576L9.91008 9.11828C9.91008 9.11828 9.12586 10.1199 7.70332 10.1199C6.11877 10.1199 4.83867 8.88419 4.83867 7.32607C4.83867 6.25759 5.49691 5.52356 5.49691 5.52356L1.71826 6.51233L0.943359 10.8085Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97225 0.331177C11.821 0.913283 13.4034 2.13535 14.3605 3.9374L9.91178 9.11461C9.91178 9.11461 10.57 8.36731 10.57 7.30547C10.57 5.71107 9.19523 4.51996 7.71006 4.51996C6.30563 4.51996 5.49902 5.51989 5.49902 5.51989V2.25831L9.97225 0.331177Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96338 2.61871C3.06758 1.32855 5.01055 0 7.68922 0C8.98883 0 9.96793 0.333196 9.96793 0.333196L5.49512 5.52271H2.32607L1.96338 2.61871Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.943574 10.8085C0.943574 10.8085 0.20459 9.39524 0.20459 7.34789C0.20459 5.41285 0.974863 3.72141 1.96328 2.61865L5.49754 5.52312L0.943574 10.8085Z",
    fill: "#F8F8F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_350_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 21,
    fill: "white",
    transform: "translate(0.20459)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d3cf21758203f6a15f3a1c710bad7ddc.svg";
export { ForwardRef as ReactComponent };